/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.23.0
 * @since 1.14.0
 */

import type { IInputSearchItem } from '@components/common/InputSearch/types';

import type { IFormAddressGetAsStringSuccessPayload } from './types/formAddressActionTypes';
import type { IFormAddressSearchResponse } from './types/formAddressTypes';

/*
 * -------------------------------------------
 *       Search for Address Matches
 * -------------------------------------------
 */

export const formAddressSearchMapping = ({
  addressElements,
}: IFormAddressSearchResponse): IInputSearchItem[] => {
  if (!addressElements || !addressElements.length) {
    return [];
  }

  return addressElements.map((address) => {
    const { id, def, type, attributes } = address;

    const addressElement: IInputSearchItem = {
      id: id.toString(),
      value: def.replace(/\[|\]/gi, ''),
      match: def.substring(def.lastIndexOf('[') + 1, def.lastIndexOf(']')),
    };

    if (type) {
      addressElement.type = type;
    }

    if (attributes) {
      addressElement.attributes = attributes;
    }

    return addressElement;
  });
};

/*
 * -------------------------------------------
 *       Get Address as String
 * -------------------------------------------
 */

export interface IFormAddressGetAsStringResponse {
  addressString?: string;
}

export const formAddressGetAsStringMapping = ({
  addressString,
}: IFormAddressGetAsStringResponse): IFormAddressGetAsStringSuccessPayload => {
  return { addressString: addressString || '' };
};
